export const selectLoggedIn = ({ session }) => session.loggedIn;
export const selectShowNdlChange = ({ session }) => session.showNdlChange;
export const selectMarketingPreferencesPopup = ({ session }) => session.marketingPreferencesPopup;
export const selectShowDepositLimitConfirmation = ({ session }) => (
  session.depositLimit.showConfirmation
);
export const selectPendingDepositLimit = ({ session }) => session.depositLimit.pendingLimit;
export const selectCustomerConsentMessages = ({ session }) => session.customerConsentMessages;
